import dayjs, { Dayjs } from "dayjs"

import { Experience } from "@/types/getAbout"

export interface ExperienceDuration {
  durationMonths: number
  durationYears: number
  endDate: Dayjs
  startDate: Dayjs
}

export function getExperienceDuration(
  experience: Experience,
  today = dayjs()
): ExperienceDuration {
  const startDate = dayjs(experience.start_date)
  const endDate = dayjs(
    experience.end_date == null ? today : experience.end_date
  )
  const totalMonths = endDate.diff(startDate, "month")

  return {
    durationMonths: totalMonths % 12,
    durationYears: Math.floor(totalMonths / 12),
    endDate,
    startDate,
  }
}
